import type {Address, BasisType, CustomerType, Goal, Partner, RRDate, Service, Time} from "@raskrask-dk/raskrask-utils";
import {SetDate, SetTime, SetDependencies, Next} from "./actions";

export type MoveBookingActions = SetDate | SetTime | SetDependencies | Next;

export const moveBookingActions = [SetDate, SetTime, SetDependencies, Next] as const;

export type moveActions = typeof moveBookingActions[number];

export interface IGetMoveBookingData {
  dependencies?: MoveBookingDependencies | undefined;
  date: RRDate | undefined;
  time: Time | undefined;
}

export interface MoveBookingDependencies {
  address: Address;
  basisType: BasisType;
  customerType: CustomerType;
  goal: Goal;
  service: Service;
  partner: Partner;
}
